import React from 'react';
import { CoreRadiobutton } from '@komodo-design-system/komodo-components-react';
import './UploadContent.scss';

interface UploadTypeSelectorProps {
  isBulkUpload: boolean;
  setIsBulkUpload: (value: boolean) => void;
}

const UploadTypeSelector: React.FC<UploadTypeSelectorProps> = ({
  isBulkUpload,
  setIsBulkUpload,
}) => {
  return (
    <div className="upload-type">
      <label className="required-field">Asset Upload Type</label>
      <CoreRadiobutton
        checked={!isBulkUpload}
        name="single_upload_radio"
        onRadioClicked={() => setIsBulkUpload(false)}
        data-testid="single_upload_radio"
        label="Single Upload"
        // disabled={isBulkUpload}
      />
      <CoreRadiobutton
        checked={isBulkUpload}
        name="bulk_upload_radio"
        onRadioClicked={() => setIsBulkUpload(true)}
        data-testid="bulk_upload_radio"
        label="Bulk Upload"
      />
    </div>
  );
};

export default UploadTypeSelector;